
namespace Slick {
    export interface Column {
        summaryType?: Serenity.SummaryType;
    }
}

namespace Serenity {

    export interface GroupSumsMetadataOptions {
        groupCssClass?: string;
        groupTitleCssClass?: string;
        totalsCssClass?: string;
        groupFocusable?: boolean,
        totalsFocusable?: boolean,
        toggleCssClass?: string,
        toggleExpandedCssClass?: string,
        toggleCollapsedCssClass?: string,
        enableExpandCollapse?: true;
        groupFormatter?: Slick.ColumnFormatter;
        totalsFormatter?: Slick.ColumnFormatter;
        getRowMetadata?: (item: any) => any;
    }

    var _defaults: GroupSumsMetadataOptions = {
        groupCssClass: "slick-group",
        groupTitleCssClass: "slick-group-title",
        totalsCssClass: "slick-group-totals",
        groupFocusable: true,
        totalsFocusable: false,
        toggleCssClass: "slick-group-toggle",
        toggleExpandedCssClass: "expanded",
        toggleCollapsedCssClass: "collapsed",
        enableExpandCollapse: true
    };

    export class GroupSumsMetadataProvider {

        private grid: Slick.Grid;
        private options: GroupSumsMetadataOptions;

        constructor(options: GroupSumsMetadataOptions) {

            options = this.options = $.extend(true, {}, _defaults, options);

            if (options.groupFormatter == null)
                options.groupFormatter = (row: number, cell: number, value: any, columnDef: Slick.Column,
                    item: any) => {
                    if (!options.enableExpandCollapse) {
                        return item.title;
                    }

                    var indentation = item.level * 15 + "px";

                    return "<span class='" + options.toggleCssClass + " " +
                        (item.collapsed ? options.toggleCollapsedCssClass : options.toggleExpandedCssClass) +
                        "' style='margin-left:" + indentation + "'>" +
                        "</span>" +
                        "<span class='" + options.groupTitleCssClass + "' level='" + item.level + "'>" +
                        item.title +
                        "</span>";
                };


            if (options.totalsFormatter == null)
                options.totalsFormatter = ((row, cell, value, columnDef, item, columnData, grid) => {
                    if (item != null && item.totals)
                        item = item.totals;
                    return (columnDef.groupTotalsFormatter && columnDef.groupTotalsFormatter(item, columnDef)) ||
                        (grid && grid.groupTotalsFormatter && grid.groupTotalsFormatter(item, columnDef)) || "";
                }) as any;
        }

        handleGridClick: any;
        handleGridKeyDown: any;

        init(grid: Slick.Grid) {
            this.grid = grid;
            var options = this.options;

            this.handleGridClick = function (this: Slick.Grid, e: JQueryEventObject, args: any) {
                var item = this.getDataItem(args.row);
                if (item && item instanceof Slick.Group && $(e.target).hasClass(options.toggleCssClass)) {
                    var range = (grid.getRenderedRange as any)();
                    this.getData()["setRefreshHints"]({
                        ignoreDiffsBefore: range.top,
                        ignoreDiffsAfter: range.bottom + 1
                    });

                    if (item.collapsed) {
                        this.getData()["expandGroup"](item.groupingKey);
                    } else {
                        this.getData()["collapseGroup"](item.groupingKey);
                    }

                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            };

            this.grid.onClick.subscribe(this.handleGridClick);

            this.handleGridKeyDown = function (e: JQueryEventObject, args: any) {
                if (options.enableExpandCollapse && (e.which == $.ui.keyCode.SPACE)) {
                    var activeCell = this.getActiveCell();
                    if (activeCell) {
                        var item = this.getDataItem(activeCell.row);
                        if (item && item instanceof Slick.Group) {
                            var range = (grid.getRenderedRange as any)();
                            this.getData().setRefreshHints({
                                ignoreDiffsBefore: range.top,
                                ignoreDiffsAfter: range.bottom + 1
                            });

                            if (item.collapsed) {
                                this.getData().expandGroup(item.groupingKey);
                            } else {
                                this.getData().collapseGroup(item.groupingKey);
                            }

                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                    }
                }
            }

            this.grid.onKeyDown.subscribe(this.handleGridKeyDown);
        }

        public destroy() {
            if (this.grid) {
                this.grid.onClick.unsubscribe(this.handleGridClick);
                this.grid.onKeyDown.unsubscribe(this.handleGridKeyDown);
            }
        }

        public getRowMetadata(item: any) {
            if (this.options.getRowMetadata) {
                return this.options.getRowMetadata(item);
            }

            return null;
        }

        public getGroupRowMetadata() {
            var groupIndex = 0;
            var colSpan = 1;
            if (this.grid) {
                var cols = this.grid.getColumns();
                for (var idx = 0; idx < cols.length; idx++) {
                    if (cols[idx].summaryType == null ||
                        cols[idx].summaryType == SummaryType.Disabled) {
                        groupIndex = idx;
                        break;
                    }
                }

                for (var idx = groupIndex + 1; idx < cols.length; idx++) {
                    if (cols[idx].summaryType == null ||
                        cols[idx].summaryType == SummaryType.Disabled) {
                        colSpan++;
                    }
                    else
                        break;
                }
            }
            return {
                selectable: false,
                focusable: this.options.totalsFocusable,
                cssClasses: this.options.groupCssClass,
                formatter: this.options.totalsFormatter,
                columns: {
                    [groupIndex]: {
                        colspan: colSpan,
                        formatter: this.options.groupFormatter,
                        editor: null
                    }
                }
            };
        }

        public getTotalsRowMetadata(item: any) {
            return {
                //selectable: false,
                //focusable: this.options.totalsFocusable,
                //cssClasses: this.options.totalsCssClass,
                //formatter: this.options.totalsFormatter,
                //editor: null
            };
        }
    }
}
